import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';

import PayTableSymbolOdds from './payTableSymbolOdds';

const PayTableSymbolsOddsWr = observer(({ item, index, oddsInfo }) => {
  const oddsRef = useRef();
  const [oddWidth, setOddWidth] = useState(0);

  useEffect(() => {
    if (oddsRef.current) {
      setOddWidth(oddsRef.current.width);
    }
  }, [oddsRef]);

  return (
    <Container
      ref={oddsRef}
      key={item.id}
      x={item.oddsContainerX - (oddWidth ? oddWidth / 2 : 0)}
      y={item.oddsContainerY}
      name='PayTableSymbolsOddsContainer'
    >
      {item.id === 9
        ? oddsInfo[index] && (
            <PayTableSymbolOdds
              id={item.id}
              key={`${item.id}-${oddsInfo[index][0]}`}
              odd={oddsInfo[oddsInfo.length - 1][0]}
              oddX={item.oddX || 0}
              oddY={item.oddY || 0}
              oddIndex={0}
              oddContainerY={item.oddContainerY}
            />
          )
        : item.id === 8
        ? oddsInfo[index]?.map((odd, oddIndex) => {
            return (
              <PayTableSymbolOdds
                id={item.id}
                key={`${item.id}${odd}`}
                odd={oddsInfo[oddsInfo.length - 2][oddIndex]}
                oddX={item.oddX || 0}
                oddY={item.oddY || 0}
                oddIndex={oddIndex}
                oddContainerY={item.oddContainerY}
              />
            );
          })
        : oddsInfo[index]?.map((odd, oddIndex) => {
            return (
              <PayTableSymbolOdds
                id={item.id}
                key={`${item.id}${odd}`}
                odd={odd}
                oddX={item.oddX || 0}
                oddY={item.oddY || 0}
                oddIndex={oddIndex}
                oddContainerY={item.oddContainerY}
              />
            );
          })}
    </Container>
  );
});

export default PayTableSymbolsOddsWr;
